site.stickyHead = {
	init:function() {
		site.stickyHead.toggleClass();
		window.addEventListener('scroll', function(){
			site.stickyHead.toggleClass();
		});
	},

	toggleClass:function() {
		var distanceY = window.pageYOffset || document.documentElement.scrollTop,
			shrinkOn = 50;
		if (distanceY > shrinkOn) {
			$('body').addClass('stickyHead');
		} else {
			$('body').removeClass('stickyHead');
		}
	}
};
